// extracted by mini-css-extract-plugin
export var container = "styles-module--container--HtXky";
export var curve = "styles-module--curve--ncSGI";